/**
 * Accordions
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;

	function toggleAccordion(element) {
		const accordionId = element.getAttribute('data-attr');
		element.classList.toggle('--active');

		const accordion = element.closest('.accordion');
		if (accordion) {
			accordion.classList.toggle('--opened');
		}

		const content = document.getElementById('accordion-' + accordionId);
		if (content) {
			const isOpen = content.style.display === 'block';
			content.style.display = isOpen ? 'none' : 'block';
			content.classList.toggle('--active');

			// ARIA updates
			element.setAttribute('aria-expanded', !isOpen);
			content.setAttribute('aria-hidden', isOpen);

			if (debug) {
				console.log(`... ${isOpen ? 'Closing' : 'Opening'} accordion ${accordionId}`);
			}
		}

		const icon = element.querySelector('.accordion__icon');
		if (icon) {
			icon.classList.toggle('--opened');
		}
	}

	function accordionButtonClicked(event) {
		if (debug) {
			console.log('Accordion button CLICKED');
		}
		toggleAccordion(event.currentTarget);
	}

	function accordionButtonExpanderClicked(event) {
		const button = event.currentTarget;
		const action = button.getAttribute('data-action');
		const sectionId = button.getAttribute('data-attr');
		const accordions = document.querySelectorAll('#' + sectionId + ' .accordion__button');

		if (debug) {
			console.log(`... Accordion expander button CLICKED in section ${sectionId}`);
		}

		const isExpanding = action === 'expand';
		button.setAttribute('data-action', isExpanding ? 'collapse' : 'expand');

		const span = button.querySelector('span');
		if (span) {
			span.innerHTML = button.getAttribute(isExpanding ? 'data-text-collapse' : 'data-text-expand');
		}
		button.classList.toggle('open', isExpanding);

		accordions.forEach((acc) => {
			const content = document.getElementById('accordion-' + acc.getAttribute('data-attr'));

			if (content) {
				if (isExpanding) {
					acc.classList.add('--active');
					content.style.display = 'block';
					content.classList.add('--active');
					acc.setAttribute('aria-expanded', 'true');
					content.setAttribute('aria-hidden', 'false');
				} else {
					acc.classList.remove('--active');
					content.style.display = 'none';
					content.classList.remove('--active');
					acc.setAttribute('aria-expanded', 'false');
					content.setAttribute('aria-hidden', 'true');
				}
			}
		});
	}

	document.querySelectorAll('.accordion__expand-all').forEach((button) => {
		button.addEventListener('click', accordionButtonExpanderClicked);
	});

	document.querySelectorAll('.accordion__button').forEach((button) => {
		button.setAttribute('aria-expanded', 'false');
		button.addEventListener('click', accordionButtonClicked);
	});
};
